/**
 * @fileoverview GET handler for the "/alloys/partners/shopify/:integration_id/fetch_segments" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { alloysPartnersShopifyFetchSegments } from "./constants";
import type { GetAlloysPartnersShopifyFetchSegmentsResult } from "./types";
import { isGetAlloysPartnersShopifyFetchSegmentsResult } from "./validators";

export const getAlloysPartnersShopifyFetchSegments = reactQueryFetcherAdapter(
  alloysPartnersShopifyFetchSegments,
  (signal: AbortSignal, integrationId: string): Promise<GetAlloysPartnersShopifyFetchSegmentsResult> => {
    return fetch(`/alloys/partners/shopify/${integrationId}/fetch_segments`, "GET", {}, { signal });
  },
  isGetAlloysPartnersShopifyFetchSegmentsResult
);
